
import toastr from 'toastr';

angular.module("persons_information_groups")

    .controller("PersonsInformationGroupsEditCtrl", [ 'LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate) {
            
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("INFORMATION_GROUPS_WRITE");
        var subtitle = "";
        if ($scope.entity_type == "persons") {
            subtitle = $filter('translate')('events.tasks.persons');
        } else if ($scope.entity_type == "events") {
            subtitle = $filter('translate')('events.title');
        }
        $rootScope.title = $filter('translate')('persons_information_groups.title') + " - " + subtitle;

        $scope.types = [
            { id: 'text', name: "Texto" },
            { id: 'number', name: "Número" },
            { id: 'select', name: "Desplegable de opciones" },
            { id: 'checkboxSimple', name: "Si/No check" },
            { id: 'datetime', name: "Fecha" }
        ];

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('persons_information_groups.title'), url: "persons_information_groups.list({ entity_type: '" + $stateParams.entity_type +"' })" },
                { title: $filter('translate')('persons_information_groups.title_add') },
            ];

            $scope.information_group = { type: "text", entity_type: $stateParams.entity_type };

        } else {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('persons_information_groups.title'), url: "persons_information_groups.list({ entity_type: '"+$stateParams.entity_type+"' })" },
                { title: $filter('translate')('persons_information_groups.title_edit') },
            ];

            Restangular.one('InformationsGroups', $stateParams.id).get().then(function (results) {                 
                $scope.information_group = results;
            });

        }
       
        /* PERSON INFORMATION GROUP */
        $scope.save = function (frmPersonsInformationGroups) {            
            
            if (!angular.isUndefined($scope.information_group.id)) {
                $scope.information_group.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('persons_information_groups.edit_success'));
                        $state.go("persons_information_groups.list", { entity_type: $stateParams.entity_type });
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('InformationsGroups').post($scope.information_group).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('persons_information_groups.created_success'));
                        $state.go("persons_information_groups.list", { entity_type: $stateParams.entity_type });
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('persons_information_groups.button_delete'),
                message: $filter('translate')('persons_information_groups.delete_message') + " " + $scope.information_group.name + "?",
                onAccept: function () {
                    $scope.information_group.remove().then(function () {
                        toastr.success($filter('translate')('persons_information_groups.delete_success'));
                        $state.go("persons_information_groups.list", { entity_type: $stateParams.entity_type });
                    });
                }
            });
        };                       

}])

;

